import GreetPost from "@/components/PostLayer/Template/GreetPost";
// import GetGoodReviewsPost from "@/components/PostLayer/Template/GetGoodReviewsPost";
import PostTemplate from "@/components/PostLayer/PostTemplate.js";
import OrderMessagePost from "@/components/PostLayer/Template/OrderMessagePost";

export default {
  name: "PostLayer",
  components: { OrderMessagePost, GreetPost },
  data () {
    return {
      PostTemplate,
      isLoadIntercom: false,
    }
  },
  created () {
    this.checkIsLoadIntercom()
  },
  mounted () {
    // 如果打开了，就主动关闭 POST
    window.Intercom('onShow', () => {
      this.$store.commit('setPostShow', false)
    });
  },
  methods: {
    closeHandle () {
      this.$emit('onShow', false)
      this.$store.commit('setPostShow', false)
    },

    newMsgHandle () {
      if (PostTemplate.GET_GOOD_REVIEWS === this.$store.getters.post.template) return
      if (this.$store.getters?.post?.handleClickShowMessage) this.showNewMessage()
    },

    showNewMessage () {
      this.$emit('onOpenNewMsg', true)
      this.closeHandle()
      window.Intercom('showNewMessage', '')
    },

    /**
     * 检测是否加载了 Intercom，每 200ms 检测一次
     */
    checkIsLoadIntercom () {
      setTimeout(() => {
        if (!document.querySelector("#intercom-frame + .intercom-lightweight-app")) {
          this.checkIsLoadIntercom()
          return
        }
        this.isLoadIntercom = true
      }, 500)
    }
  },
  computed: {
    /**
     * 是否展示
     * @returns {Boolean}
     */
    show () {
      return this.$store.getters.post.show
    },

    /**
     * 模版 ID
     * @returns {Number}
     */
    template () {
      return this.$store.getters.post.template
    },

    /**
     * 用户名
     * @returns {string|*}
     */
    userName () {
      return this.$store.state.userName || ''
    },
  }
}